import { render, staticRenderFns } from "./ChangeFacility.vue?vue&type=template&id=f32ed478&scoped=true&"
import script from "./ChangeFacility.vue?vue&type=script&lang=js&"
export * from "./ChangeFacility.vue?vue&type=script&lang=js&"
import style0 from "./ChangeFacility.vue?vue&type=style&index=0&id=f32ed478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32ed478",
  null
  
)

export default component.exports